import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { TranslationProvider } from './context/TranslationContext';
import { AuthProvider } from './context/AuthContext';
import { RequireAuth } from './components/RequireAuth';
import { Home } from './pages/Home';
import { GapAnalysis } from './pages/GapAnalysis';
import { DocumentsList } from './pages/DocumentsList';
import { TranslationHub } from './pages/TranslationHub';
import { SegmentWorkspace } from './pages/SegmentWorkspace';
import { Settings } from './pages/Settings';
import { LoginPage } from './pages/LoginPage';
export function App() {
  return <AuthProvider data-id="element-0">
      <TranslationProvider data-id="element-1">
        <Router data-id="element-2">
          <div className="min-h-screen bg-slate-50 text-slate-900 font-sans" data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/login" element={<LoginPage data-id="element-6" />} data-id="element-5" />
              <Route path="/" element={<RequireAuth data-id="element-8">
                    <Home data-id="element-9" />
                  </RequireAuth>} data-id="element-7" />
              
              <Route path="/translation" element={<RequireAuth data-id="element-11">
                    <DocumentsList data-id="element-12" />
                  </RequireAuth>} data-id="element-10" />
              
              <Route path="/gap-analysis" element={<RequireAuth data-id="element-14">
                    <GapAnalysis data-id="element-15" />
                  </RequireAuth>} data-id="element-13" />
              
              <Route path="/settings" element={<RequireAuth data-id="element-17">
                    <Settings data-id="element-18" />
                  </RequireAuth>} data-id="element-16" />
              
              <Route path="/document/:docId" element={<RequireAuth data-id="element-20">
                    <TranslationHub data-id="element-21" />
                  </RequireAuth>} data-id="element-19" />
              
              <Route path="/document/:docId/translate/:segmentId" element={<RequireAuth data-id="element-23">
                    <SegmentWorkspace data-id="element-24" />
                  </RequireAuth>} data-id="element-22" />
              
            </Routes>
          </div>
          <Toaster position="bottom-right" richColors data-id="element-25" />
        </Router>
      </TranslationProvider>
    </AuthProvider>;
}